import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import styles from "./ConfirmMessage.module.css";


function ConfirmMessage(props){
  const [confirmAction, setConfirmAction] = useState(false);

  const handleAction = () => {
    props.onConfirmAct();
    setTimeout(() => {
      setConfirmAction(false);
    }, 500);
  };

  const closeModal = () => {
    props.onHide();
    setTimeout(() => {
      setConfirmAction(false);
    }, 500);
  };

  return (
    <Modal
      show={props.show}
      onHide={closeModal}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={styles.modalHeader}
        >
          {props.confirmHeader}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <p>{props.confirmBody}</p>
      </Modal.Body>
      <div className={styles.modalFooter}>
        {confirmAction ? (
          <>
            <button
              onClick={handleAction}
              className={`mr-3 ${styles.allBtn} ${styles.actionBtn} ${styles.actionConfirmBtn}`}
            >
              Confirm
              <span>
                <i className={`fa fa-check-circle ${styles.actionIcon}`} />
              </span>
            </button>
            <button
              onClick={closeModal}
              className={`${styles.allBtn} ${styles.cancelBtn} ${styles.cancelConfirmBtn}`}
            >
              Cancel
              <span>
                <i className={`fa fa-undo ${styles.cancelIcon}`}/>
              </span>
            </button>
          </>
        ) : (
          <>
            <button onClick={() => setConfirmAction(true)} className={`${styles.allBtn} ${styles.actionBtn}`}>
              {props.status ? 'Disconnect' : 'Connect'}
            </button>
            <button onClick={closeModal} className={`${styles.allBtn} ${styles.cancelBtn}`}>
              Cancel
            </button>
          </>
        )}
      </div>
    </Modal>
  );
}

export default ConfirmMessage; 